const SvgCard = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M28 8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zM4 7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm-1.333 9h26.667v-4H2.667zm26.667 0H2.667v-4h26.667zm-1-3H3.667v2h24.667z" />
  </svg>;
export default SvgCard;